// extracted by mini-css-extract-plugin
module.exports = {"row-divider":"WithdrawalSuccessfulOperation_row-divider_14O_B"};